window.addEventListener('load', () => {
    const treatments = document.querySelectorAll('.treatment');
    let openTreatmentElement = null;

    if (window.openTreatment) {
        openTreatmentElement = document.querySelector(`#treatment-${window.openTreatment}`);
    }

    if (treatments.length) {
        gsap.fromTo(treatments, {
            xPercent: 5,
        }, {
            xPercent: 0,
            autoAlpha: 1,
            stagger: 0.1,
            onComplete() {
                if (openTreatmentElement) {
                    const header = document.querySelector('header.header');
                    window.scrollTo(0, openTreatmentElement.offsetTop - header.clientHeight);
                    openTreatmentElement.querySelector('.treatment-show').click();
                }
            },
        });
    }

    const showButtons = document.querySelectorAll('.treatment-show');

    showButtons.forEach(showButton => {
        showButton.addEventListener('click', e => {
            e.preventDefault();

            let showTimeline = gsap.timeline();
            const treatment = showButton.closest('.treatment');
            const treatmentContent = treatment.querySelector('.treatment-content');

            document.querySelectorAll('.treatment.open').forEach(openTreatment => {
                openTreatment.querySelector('.treatment-hide').click();
            });

            treatment.classList.add('open');

            showTimeline.set(treatment, {
                minHeight: treatment.offsetHeight,
            }).to(showButton, {
                xPercent: 25,
                autoAlpha: 0,
                duration: 0.25,
                display: 'none',
            }).fromTo(treatmentContent, {
                autoAlpha: 0,
                yPercent: -100,
            },{
                height: 'auto',
                duration: 0.25,
            }).to(treatmentContent, {
                yPercent: 0,
                autoAlpha: 1,
                duration: 0.25,
            });
        });
    });

    const hideButtons = document.querySelectorAll('.treatment-hide');

    hideButtons.forEach(hideButton => {
        hideButton.addEventListener('click', e => {
            e.preventDefault();

            let hideTimeline = gsap.timeline();
            const treatment = hideButton.closest('.treatment');
            const showButton = treatment.querySelector('.treatment-show');
            const treatmentContent = treatment.querySelector('.treatment-content');

            treatment.classList.remove('open');

            hideTimeline.to(treatmentContent, {
                autoAlpha: 0,
                yPercent: 100,
                duration: 0.25,
            }).to(treatmentContent, {
                height: 0,
                duration: 0.25,
            }).set(showButton, {
                display: 'block',
            }).to(showButton, {
                xPercent: 0,
                autoAlpha: 1,
                duration: 0.25,
            });
        });
    });
});
